import styled from 'styled-components'

import {
  Grid,
  List,
  ListItemText as MuiListItemText,
  ListItemButtonProps as MuiListItemButtonProps,
  ListItemButton as MuiListItemButton,
  Stack,
  Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { NavLink, NavLinkProps } from 'react-router-dom'
import BugReportButton from './BugReportButton'

type ListItemButtonProps = MuiListItemButtonProps & NavLinkProps

const Wrapper = styled('div')`
  display: flex;
  padding: ${(props) => props.theme.spacing(0.25)} ${(props) => props.theme.spacing(4)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
  height: 56px;
`

const ListItemButton = styled(MuiListItemButton)<ListItemButtonProps>`
  display: inline-block;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: ${(props) => props.theme.palette?.text?.primary};
  }
`

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.palette?.text?.primary};
    /* increase weight slightly for better readability */
    font-weight: 500;
  }
`

function Footer() {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid sx={{ display: { xs: 'none', md: 'block' } }} item xs={12} md={6}>
          <List
            sx={{
              display: 'inline-flex',
              p: '0 !important',
              height: '100%'
            }}
          >
            <ListItemButton component={NavLink} to="/user-manual">
              <ListItemText primary={t('userManual')} />
            </ListItemButton>
            <ListItemButton component={NavLink} to="/privacy-policy">
              <ListItemText primary={t('privacyPolicy')} />
            </ListItemButton>
            <ListItemButton component={NavLink} to="/terms-of-service">
              <ListItemText primary={t('termsOfService')} />
            </ListItemButton>
            <ListItemButton component={NavLink} to="/changelog">
              <ListItemText primary={t('changelog')} />
            </ListItemButton>
          </List>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent={{ xs: 'space-between', md: 'flex-end' }}
            gap={6}
            sx={{
              height: '100%'
            }}
          >
            <BugReportButton
              color="primary"
              variant="contained"
              size="small"
              sx={{
                flexShrink: 0,
                alignSelf: 'center'
              }}
            />
            <Typography>{`© ${new Date().getFullYear()} - Spine`}</Typography>
          </Stack>
        </Grid>
      </Grid>
    </Wrapper>
  )
}

export default Footer
